import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './layout/header/header';
import { Footer } from './layout/footer/footer';
import { MapSection } from './layout/map/map';
import { ScrollToTop } from './shared/scroll-to-top/scroll-to-top';
import { ToastContainer } from './shared/toast/toast-container';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, MapSection, ScrollToTop, ToastContainer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
